import { render, staticRenderFns } from "./Consentements.vue?vue&type=template&id=c57b30f2"
import script from "./Consentements.vue?vue&type=script&lang=js"
export * from "./Consentements.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports